import { useSetAtom } from 'jotai'
import React from 'react'

import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'

import { dialogInfoAtom } from '../atoms'
import { type DocumentImage } from '../hooks/useFetchDocumentImages'

export type EditButtonProps = {
  documentImage: DocumentImage
}

export const EditButton = ({ documentImage }: EditButtonProps) => {
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleClick = React.useCallback<EH<IconButtonProps, 'onClick'>>(() => {
    setDialogInfo({ dialogType: 'update', documentImage })
  }, [documentImage, setDialogInfo])

  return (
    <IconButton
      buttonStyle="light"
      fillMode="flat"
      icon="edit"
      onClick={handleClick}
    />
  )
}
